 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"icons/icon-account-svg":"icons/icon-account-svg","icons/icon-charges-svg":"icons/icon-charges-svg","icons/icon-check-svg":"icons/icon-check-svg","icons/icon-circle-dot-svg":"icons/icon-circle-dot-svg","icons/icon-circle-svg":"icons/icon-circle-svg","icons/icon-client-svg":"icons/icon-client-svg","icons/icon-close-svg":"icons/icon-close-svg","icons/icon-configuration-svg":"icons/icon-configuration-svg","icons/icon-copy-svg":"icons/icon-copy-svg","icons/icon-cred-card-svg":"icons/icon-cred-card-svg","icons/icon-customers-svg":"icons/icon-customers-svg","icons/icon-dashboard-svg":"icons/icon-dashboard-svg","icons/icon-developer-svg":"icons/icon-developer-svg","icons/icon-direction-svg":"icons/icon-direction-svg","icons/icon-download-svg":"icons/icon-download-svg","icons/icon-edit-svg":"icons/icon-edit-svg","icons/icon-ellipsis-svg":"icons/icon-ellipsis-svg","icons/icon-fees-svg":"icons/icon-fees-svg","icons/icon-freearea-svg":"icons/icon-freearea-svg","icons/icon-hub-svg":"icons/icon-hub-svg","icons/icon-info-svg":"icons/icon-info-svg","icons/icon-invites-svg":"icons/icon-invites-svg","icons/icon-invoices-svg":"icons/icon-invoices-svg","icons/icon-learn-more-svg":"icons/icon-learn-more-svg","icons/icon-logoJPM-svg":"icons/icon-logoJPM-svg","icons/icon-logs-svg":"icons/icon-logs-svg","icons/icon-merchant-svg":"icons/icon-merchant-svg","icons/icon-mundi-svg":"icons/icon-mundi-svg","icons/icon-no-results-svg":"icons/icon-no-results-svg","icons/icon-notification-svg":"icons/icon-notification-svg","icons/icon-orders-svg":"icons/icon-orders-svg","icons/icon-pagarme-svg":"icons/icon-pagarme-svg","icons/icon-payment-links-svg":"icons/icon-payment-links-svg","icons/icon-payments-svg":"icons/icon-payments-svg","icons/icon-permission-svg":"icons/icon-permission-svg","icons/icon-pix-outline-svg":"icons/icon-pix-outline-svg","icons/icon-pix-svg":"icons/icon-pix-svg","icons/icon-plans-svg":"icons/icon-plans-svg","icons/icon-pos-svg":"icons/icon-pos-svg","icons/icon-profile-svg":"icons/icon-profile-svg","icons/icon-recurrence-svg":"icons/icon-recurrence-svg","icons/icon-security-svg":"icons/icon-security-svg","icons/icon-shop-svg":"icons/icon-shop-svg","icons/icon-statistics-svg":"icons/icon-statistics-svg","icons/icon-subscription-svg":"icons/icon-subscription-svg","icons/icon-subscriptions-svg":"icons/icon-subscriptions-svg","icons/icon-test-svg":"icons/icon-test-svg","icons/icon-trf-svg":"icons/icon-trf-svg","icons/icon-users-solid-svg":"icons/icon-users-solid-svg","icons/icon-users-svg":"icons/icon-users-svg","icons/icon-webhooks-config-svg":"icons/icon-webhooks-config-svg","icons/icon-webhooks-skeleton-svg":"icons/icon-webhooks-skeleton-svg","icons/icon-webhooks-svg":"icons/icon-webhooks-svg"}[chunkId]||chunkId) + ".chunk.js?id=" + {"icons/icon-account-svg":"a748cac6fa8baa6b239d","icons/icon-charges-svg":"3ac74014ba53a1857520","icons/icon-check-svg":"f83fab1a76982ca93eb9","icons/icon-circle-dot-svg":"1da827b5101fa843b716","icons/icon-circle-svg":"c6d572984bcf597a0fa9","icons/icon-client-svg":"fdd645e4cd6f190a42e7","icons/icon-close-svg":"ccd72dc1bdd7053cdc01","icons/icon-configuration-svg":"918f295af39db3301cfb","icons/icon-copy-svg":"6fd3fec24f6861ad3bd1","icons/icon-cred-card-svg":"f36fb5d68b024c3596d5","icons/icon-customers-svg":"a3e572d3d55a70a895b5","icons/icon-dashboard-svg":"a56a1e06fe609011bb90","icons/icon-developer-svg":"f2506ea9c4e7a9e8e2fd","icons/icon-direction-svg":"5b79645b0401d7f756a2","icons/icon-download-svg":"3127ef93dcb11cead062","icons/icon-edit-svg":"56968bb9193fb77d07db","icons/icon-ellipsis-svg":"a193210d12a7dff75960","icons/icon-fees-svg":"05fb313c0d454a24ba97","icons/icon-freearea-svg":"e82c9602a700af280aaf","icons/icon-hub-svg":"210842e70ae4c1da7438","icons/icon-info-svg":"0e38895146cd65d75e98","icons/icon-invites-svg":"3c55d06f535cc0d66b8f","icons/icon-invoices-svg":"0036f71a7cff38b0184f","icons/icon-learn-more-svg":"a79cdc3503c63cf1b7a5","icons/icon-logoJPM-svg":"935827bf4b13f6ee60b4","icons/icon-logs-svg":"9a7912816ce205fb7851","icons/icon-merchant-svg":"e05d349f18bb1147f4a7","icons/icon-mundi-svg":"1d15174ad821b763aab8","icons/icon-no-results-svg":"e1a47c1a86d8e2c513ce","icons/icon-notification-svg":"66698a76465c7fd01d12","icons/icon-orders-svg":"9f56533850a34b72be09","icons/icon-pagarme-svg":"7d6a5ff5434020f3881c","icons/icon-payment-links-svg":"6c113bf36334999f0473","icons/icon-payments-svg":"2efc11b56f36b47a92a9","icons/icon-permission-svg":"956fa4a523441cb70d3c","icons/icon-pix-outline-svg":"c77a84b7c456c448f9d6","icons/icon-pix-svg":"bfa7f4672f43b472dfd5","icons/icon-plans-svg":"b8339f7892b6ba9d4c2d","icons/icon-pos-svg":"a1ec976940b4fbeb1941","icons/icon-profile-svg":"07ef3c3c4532ef712ab7","icons/icon-recurrence-svg":"62e58448ad12478cbc8c","icons/icon-security-svg":"1319de226cd537522dc0","icons/icon-shop-svg":"0587a1f467cec5daf266","icons/icon-statistics-svg":"6f2dba21082eeef1eec4","icons/icon-subscription-svg":"da0d724b562db90d9bac","icons/icon-subscriptions-svg":"5586569c029f901f40ae","icons/icon-test-svg":"7f4f9f24b5da71d43475","icons/icon-trf-svg":"9f9e021d60ec48479d39","icons/icon-users-solid-svg":"2bb23876ebae28178bb0","icons/icon-users-svg":"8044aabf0d7f1fd3ee93","icons/icon-webhooks-config-svg":"30bed08eb5dc13cce955","icons/icon-webhooks-skeleton-svg":"6153a1334be2fbcdd067","icons/icon-webhooks-svg":"21d82b5aef8fb1eae7ec"}[chunkId] + ""
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
